import { ARBITRUM, AVALANCHE } from "./chains";

export const SUBGRAPH_URLS = {
  [ARBITRUM]: {
    stats: "https://api.thegraph.com/subgraphs/name/ether0405/vmfinance-stats",
    referrals: "https://api.thegraph.com/subgraphs/name/ether0405/vmfinance-refferals",
    nissohVault: "https://api.thegraph.com/subgraphs/name/nissoh/gmx-vault",
  },

  [AVALANCHE]: {
    stats: "https://api.thegraph.com/subgraphs/name/ether0405/vmfinance-stats",
    // stats: "https://api.thegraph.com/subgraphs/name/hspdev0814/mmx_avalanche_trade_info_test",
    referrals: "https://api.thegraph.com/subgraphs/name/ether0405/vmfinance-refferals",
    trades:"https://api.thegraph.com/subgraphs/name/ether0405/vmfinance-trade",
  },

  common: {
    chainLink: "https://api.thegraph.com/subgraphs/name/deividask/chainlink",
  },
};
